import { getProductExceptionItem } from '@/utils/general.utils';
import type { HomeNewsItem } from '@/types/home/home-news.types';

export const HOME_BANNER_LOADING_IMAGE_URL =
    '/Content/doc/cht/banner/banner_loading.jpg';

export const HOME_LATEST_NEWS_IMAGE_URL =
    '/Content/doc/cht/home_page/latest_news.png';

const superClassIconPath = '/Images/CoeditionMainClassGroupIcon/';

export type HomeBannerItem = {
    content?: string;
    link?: string;
    act?: number;
    timeout?: number;
};

export type HomeThemeProduct = {
    SuperClassID?: string;
    MainClassID?: string;
    SubMainClassID?: string;
    SubMainClassName?: string;
    ProductClassID?: string;
    ClassLevel?: string;
    Name?: string;
    Description?: string;
    ProductCode?: string;
    Type?: number;
    Image?: string;
    ImageDetail?: string[];
    MinOrderQty?: number;
    Unit?: string;
    Price?: number;
};

export type HomeTheme = {
    ThemeID?: string;
    ThemeName?: string;
    ClassList?: HomeThemeProduct[];
};

export type HomeProductClass = {
    ProductClassID?: string;
    ProductClassName?: string;
    SubMainClassID?: string;
    SubMainClassName?: string;
    ProductCode?: string;
    Type?: number;
    ClassLevel?: string;
    Image?: string;
    ImageDetail?: string[];
    MinOrderQty?: number;
    Unit?: string;
    Price?: number;
};

export type HomeProductMainClass = {
    MainClassID?: string;
    MainClassName?: string;
    ProductCode?: string;
    ProductClassList?: HomeProductClass[];
};

export type HomeProductSuperClass = {
    SuperClassID?: string;
    SuperClassName?: string;
    SuperClassNameBar?: string;
    ProductMainClassList?: HomeProductMainClass[];
};

export type HomePopAdState = {
    id?: string;
    title?: string;
    link?: string;
    act?: number;
    isVideo?: boolean;
    mediaUrl?: string;
    mediaCacheUrl?: string;
    shouldShow?: boolean;
};

export type HomeIndexInitialState = {
    isAuthenticated?: boolean;
    bannerList?: HomeBannerItem[];
    featuredProducts?: HomeThemeProduct[];
    themeList?: HomeTheme[];
    superClassList?: HomeProductSuperClass[];
    newsList?: HomeNewsItem[];
    popAd?: HomePopAdState | null;
};

export type ProductFrameItem = {
    productClassID: string;
    productClassName: string;
    productDesc?: string;
    productCode: string;
    productType: number;
    subMainClassName: string;
    mainImage: string;
    imageDetailList: string[];
    imageAlt: string;
    minOrderQtyText: string | number;
    unit: string;
    priceText: string | number;
    exceptionItem: ReturnType<typeof getProductExceptionItem> | null;
    url: string;
};

export const homeSuperClassSidebarItems = [
    {
        value: 'BusinessCard',
        label: '名片/卡片',
        image: `${superClassIconPath}BusinessCard.svg`,
        imageAlt: '名片/卡片 分類圖示',
        url: '/ProductCategory/ProductsClassification/BusinessCard/NormalBusinessCard',
    },
    {
        value: 'StickerTape',
        label: '貼紙/膠帶',
        image: `${superClassIconPath}StickerTape.svg`,
        imageAlt: '貼紙/膠帶 分類圖示',
        url: '/ProductCategory/ProductsClassification/StickerTape/NormalSticker',
    },
    {
        value: 'Poster',
        label: '傳單DM/海報',
        image: `${superClassIconPath}Poster.svg`,
        imageAlt: '傳單DM/海報 分類圖示',
        url: '/ProductCategory/ProductsClassification/Poster/NormalPoster',
    },
    {
        value: 'MonoChromeForm',
        label: '聯單/單據',
        image: `${superClassIconPath}MonoChromeForm.svg`,
        imageAlt: '聯單/單據 分類圖示',
        url: '/ProductCategory/ProductsClassification/MonoChromeForm/MonoChromeForm',
    },
    {
        value: 'EnvelopeLetter',
        label: '信封信紙',
        image: `${superClassIconPath}EnvelopeLetter.svg`,
        imageAlt: '信封信紙 分類圖示',
        url: '/ProductCategory/ProductsClassification/EnvelopeLetter/NormalEnvelope',
    },
    {
        value: 'Photobook',
        label: '相片書/書冊',
        image: `${superClassIconPath}Photobook.svg`,
        imageAlt: '相片書/書冊 分類圖示',
        url: '/ProductCategory/ProductsClassification/Photobook/HardcoverPhotobook',
    },
    {
        value: 'Menu',
        label: '型錄菜單/文宣',
        image: `${superClassIconPath}Menu.svg`,
        imageAlt: '型錄菜單/文宣 分類圖示',
        url: '/ProductCategory/ProductsClassification/Menu/CatalogueMenu',
    },
    {
        value: 'MultiPurpose',
        label: '多功能商品',
        image: `${superClassIconPath}MultiPurpose.svg`,
        imageAlt: '多功能商品 分類圖示',
        url: '/ProductCategory/ProductsClassification/MultiPurpose/TumblerThermos',
    },
    {
        value: 'LargeFormatPrinting',
        label: '室內外大圖廣告',
        image: `${superClassIconPath}LargeFormatPrinting.svg`,
        imageAlt: '室內外大圖廣告 分類圖示',
        url: '/ProductCategory/ProductsClassification/LargeFormatPrinting/LargeFormatPrinting',
    },
    {
        value: 'Calendar',
        label: '年月曆/桌曆',
        image: `${superClassIconPath}Calendar.svg`,
        imageAlt: '年月曆/桌曆 分類圖示',
        url: '/ProductCategory/ProductsClassification/Calendar/DeskCalendar',
    },
    {
        value: 'Package',
        label: '商品包装',
        image: `${superClassIconPath}Package.svg`,
        imageAlt: '商品包装 分類圖示',
        url: '/ProductCategory/ProductsClassification/Package/Carton',
    },
    {
        value: 'PaperBag',
        label: '紙袋',
        image: `${superClassIconPath}PaperBag.svg`,
        imageAlt: '紙袋 分類圖示',
        url: '/ProductCategory/ProductsClassification/PaperBag/CottonRopePaperBag',
    },
    {
        value: 'FlexiblePackage',
        label: '軟包',
        image: `${superClassIconPath}FlexiblePackage.svg`,
        imageAlt: '軟包 分類圖示',
        url: '/ProductCategory/ProductsClassification/FlexiblePackage/2SideFlatPouch',
    },
    {
        value: 'ReadyProduct',
        label: '現成商品',
        image: `${superClassIconPath}ReadyProduct.svg`,
        imageAlt: '現成商品 分類圖示',
        url: '/ProductCategory/ProductsClassification/ReadyProduct/Sample',
    },
    {
        value: 'Services',
        label: '其他服務',
        image: `${superClassIconPath}Services.svg`,
        imageAlt: '其他服務 分類圖示',
        url: '/ProductCategory/ProductsClassification/Services/Offset',
    },
    {
        value: 'PostProcessing',
        label: '後加工',
        image: `${superClassIconPath}PostProcessing.svg`,
        imageAlt: '後加工 分類圖示',
        url: '/ProductCategory/ProductsClassification/PostProcessing/PostProcessing',
    },
];

export const homeFaqLinkList = [
    {
        title: '會員相關問題',
        subtitle: '健豪線上會員申請與服務指南',
        url: '/Home/faq?b=a01',
        iconClass: 'faq_01',
    },
    {
        title: '商品製稿相關問題',
        subtitle: '從發稿到交件，健豪印刷全流程詳解',
        url: '/Home/faq?b=a03',
        iconClass: 'faq_02',
    },
    {
        title: '交易付款&售後服務',
        subtitle: '交易付款、發票與售後服務須知',
        url: '/Home/faq?b=a02',
        iconClass: 'faq_03',
    },
];

export const buildHomeQuickLinkList = (isAuthenticated: boolean) => {
    return [
        {
            id: '',
            title: isAuthenticated ? '作品集' : '會員專屬服務',
            subtitle: '',
            url: isAuthenticated ? '/Portfolio/Index' : '/Account',
            iconClass: isAuthenticated ? 'quick_portfolio' : 'quick_account',
            extraClass: '',
        },
        {
            id: '',
            title: '訂單查詢',
            subtitle: '',
            url: '/Account/OrderHistoryV2',
            iconClass: 'quick_orderhistory',
            extraClass: '',
        },
        {
            id: '',
            title: '雲端數位書籍',
            subtitle: '(10本起印)',
            url: 'https://wish.gainhow.tw/ProductDetail/66420dd2-f1ca-11ec-a1ff-0242ac1b0002',
            iconClass: 'quick_rgbbook',
            extraClass: '',
        },
        {
            // 未登入時帶 id，讓 GlobalHeader 的 ShowLoginHandler 以 id 判斷並顯示企業代號登入區塊
            id: isAuthenticated ? '' : 'EnterpriseLogin',
            title: '企業專區',
            subtitle: '',
            // 未登入時為 BtnShowLogin 動作連結，url 留空不輸出 href，避免無法檢索的 javascript:void(0)
            url: isAuthenticated ? '/EnterprisePortal/Product' : '',
            iconClass: 'quick_enterprise',
            extraClass: isAuthenticated ? '' : 'BtnShowLogin',
        },
    ];
};

export const resolveHomeIndexInitialState = (): HomeIndexInitialState => {
    const rawState = window.__GH_SSR_INITIAL_STATE__;
    if (!rawState || typeof rawState !== 'object') {
        return {
            isAuthenticated: false,
            bannerList: [],
            featuredProducts: [],
            themeList: [],
            superClassList: [],
            newsList: [],
            popAd: null,
        };
    }

    const state = rawState as HomeIndexInitialState;
    return {
        isAuthenticated: !!state.isAuthenticated,
        bannerList: Array.isArray(state.bannerList) ? state.bannerList : [],
        featuredProducts: Array.isArray(state.featuredProducts)
            ? state.featuredProducts
            : [],
        themeList: Array.isArray(state.themeList) ? state.themeList : [],
        superClassList: Array.isArray(state.superClassList)
            ? state.superClassList
            : [],
        newsList: Array.isArray(state.newsList) ? state.newsList : [],
        popAd: state.popAd || null,
    };
};

export const resolveInitialSuperSidebarId = (
    sidebarItems: Array<{ value?: string | number }>
) => {
    const queryParams = new URLSearchParams(window.location.search);
    const querySuperClassID = queryParams.get('SuperClassID');
    if (!querySuperClassID) {
        return '';
    }

    return sidebarItems.some(
        (item) => String(item.value || '') === querySuperClassID
    )
        ? querySuperClassID
        : '';
};

export const resolveInitialThemeId = (themeList: HomeTheme[]): string => {
    return themeList.length > 0 && themeList[0].ThemeID
        ? String(themeList[0].ThemeID)
        : '';
};

export const resolveInitialMainClassIdMap = (
    superClassList: HomeProductSuperClass[]
) => {
    return superClassList.reduce<Record<string, string>>(
        (result, superClass) => {
            const superClassId = String(superClass.SuperClassID || '');
            const mainClassList = Array.isArray(superClass.ProductMainClassList)
                ? superClass.ProductMainClassList
                : [];
            if (!superClassId || mainClassList.length === 0) {
                return result;
            }

            const firstMainClassId = String(mainClassList[0].MainClassID || '');
            if (firstMainClassId) {
                result[superClassId] = firstMainClassId;
            }

            return result;
        },
        {}
    );
};

export const buildThemeSidebarItems = (themeList: HomeTheme[]) => {
    return themeList.map((theme) => ({
        value: String(theme.ThemeID || ''),
        label: theme.ThemeName || '',
        svg: getThemeIconName(String(theme.ThemeID || '')),
        ThemeID: String(theme.ThemeID || ''),
        ThemeName: theme.ThemeName || '',
        IconName: getThemeIconName(String(theme.ThemeID || '')),
    }));
};

export const getThemeIconName = (themeId: string) => {
    const themeIconMap: Record<string, string> = {
        themesport: 'sport-tennis-regular',
        themeschool: 'book-open-regular',
        themeexhibition: 'exhibition-regular',
        themebusiness: 'business-bag-regular',
        themeoffice: 'office-chart-regular',
        themehomedeco: 'home-eaves-regular',
        themeagency: 'agency-regular',
        themewedding: 'heart-double-regular',
        themesale: 'bullhorn-regular',
        themegift: 'gift-regular',
        themerestaurant: 'fork-knife-regular',
        themecampaign: 'campaign-regular',
    };
    return themeIconMap[String(themeId || '').toLowerCase()] || '';
};

export const getProductClassImageUrl = (
    imageName?: string,
    classLevel = 'ProductClass'
) => {
    if (!imageName) return '/Images/ComingSoon.png';

    let folder = '';
    if (classLevel === 'MainClass') folder = 'MainClass';
    else if (classLevel === 'SubMainClass') folder = 'SubMainClass';
    else if (classLevel === 'ProductClass') folder = 'Class';
    else if (classLevel === 'Detail') folder = 'Detail';

    return `/Images/FindPrice/${folder}/${imageName}`;
};

export const getProductsClassificationUrl = (
    superClassID?: string,
    mainClassID?: string,
    subMainClassID?: string,
    productClassID?: string,
    index: number | null = null
) => {
    const normalizedSuperClassID = String(superClassID || '').trim();
    const normalizedMainClassID = String(mainClassID || '').trim();
    let normalizedSubMainClassID = String(subMainClassID || '').trim();
    let normalizedProductClassID = String(productClassID || '').trim();

    if (index !== null && index < 3) {
        normalizedSubMainClassID = '';
        normalizedProductClassID = '';
    }

    if (!normalizedMainClassID) {
        return `/ProductCategory/ProductsClassification/${encodeURIComponent(normalizedSuperClassID)}`;
    }

    let productUrl = `/ProductCategory/ProductsClassification/${encodeURIComponent(normalizedSuperClassID)}/${encodeURIComponent(normalizedMainClassID)}`;
    const queryParts = [];
    if (normalizedSubMainClassID) {
        queryParts.push(
            `SubMainClassID=${encodeURIComponent(normalizedSubMainClassID)}`
        );
    }
    if (normalizedProductClassID) {
        queryParts.push(
            `ProductClassID=${encodeURIComponent(normalizedProductClassID)}`
        );
    }
    if (queryParts.length > 0) {
        productUrl += `?${queryParts.join('&')}`;
    }

    return productUrl;
};

export const normalizeThemeProductToFrameProduct = (
    product: HomeThemeProduct
): ProductFrameItem => {
    const productType = Number(product.Type || 0);

    return {
        productClassID: String(product.ProductClassID || ''),
        productClassName: product.Name || '',
        productCode: product.ProductCode || '',
        productType,
        subMainClassName: product.SubMainClassName || '',
        mainImage: getProductClassImageUrl(
            product.Image,
            product.ClassLevel || 'ProductClass'
        ),
        imageDetailList: Array.isArray(product.ImageDetail)
            ? product.ImageDetail.map((item) =>
                  getProductClassImageUrl(item, 'Detail')
              )
            : [],
        imageAlt: product.Name || '',
        minOrderQtyText: formatNumber(product.MinOrderQty),
        unit: product.Unit || '',
        priceText: formatPrice(product.Price),
        exceptionItem: getProductExceptionItem(productType) || null,
        url: getProductsClassificationUrl(
            product.SuperClassID,
            product.MainClassID,
            product.SubMainClassID,
            product.ProductClassID
        ),
    };
};

// 快速編輯商品在主打商品正規化的基礎上補上商品描述，並在缺 ProductClassID 時退回 MainClassID
export const normalizeQuickEditProductToFrameProduct = (
    product: HomeThemeProduct
): ProductFrameItem => {
    const normalizedProduct = normalizeThemeProductToFrameProduct(product);
    const productClassID =
        normalizedProduct.productClassID || String(product.MainClassID || '');

    return {
        ...normalizedProduct,
        productClassID,
        productDesc: product.Description || '',
    };
};

export const normalizeMainClassProductToFrameProduct = (
    superClassID: string,
    mainClassID: string,
    productClass: HomeProductClass,
    index: number
): ProductFrameItem => {
    const productType = Number(productClass.Type || 0);

    return {
        productClassID: String(productClass.ProductClassID || ''),
        productClassName: productClass.ProductClassName || '',
        productCode: productClass.ProductCode || '',
        productType,
        subMainClassName: productClass.SubMainClassName || '',
        mainImage: getProductClassImageUrl(
            productClass.Image,
            productClass.ClassLevel || 'ProductClass'
        ),
        imageDetailList: Array.isArray(productClass.ImageDetail)
            ? productClass.ImageDetail.map((item) =>
                  getProductClassImageUrl(item, 'Detail')
              )
            : [],
        imageAlt: productClass.ProductClassName || '',
        minOrderQtyText: formatNumber(productClass.MinOrderQty),
        unit: productClass.Unit || '',
        priceText: formatPrice(productClass.Price),
        exceptionItem: getProductExceptionItem(productType) || null,
        url: getProductsClassificationUrl(
            superClassID,
            mainClassID,
            productClass.SubMainClassID,
            productClass.ProductClassID,
            index
        ),
    };
};

const formatNumber = (value?: number) => {
    if (!value || value === 0) return '--';
    return Number(value).toLocaleString('en-US');
};

const formatPrice = (value?: number) => {
    if (!value || value === 0) return '--';
    return Math.floor(Number(value)).toLocaleString('en-US');
};
